/**
 * Created by joe on 3/5/2020.
 */

const _ = (global && global._) || require('lodash');

// modifies obj with all keys renamed.  if key does not exist, then no remapping occurs
const lodash_renameKeys = function(obj, keyMap) {
  if (!_.isEmpty(obj)) {
    _.each(keyMap, (k2, k1) => {
      if (k1 && k2 && _.has(obj, k1)) {
        _.set(obj, k2, _.get(obj, k1));
        _.unset(obj, k1);
      }
    });
  }
  return obj;
};

_.mixin({
  renameKeys: lodash_renameKeys,
});

module.exports = _.bind(lodash_renameKeys);


